import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => {
  //console.log(theme.zIndex,'dtheme.zIndex')
  return {
    filterPaperWrapper: {
      width: 450,
      maxHeight: 230,
      overflow: 'auto',
    },
    paper: {
      zIndex: theme.zIndex.modal,
    },
    advancedFilter: {
      zIndex: 9999,
    },
    inputWidth: {
      maxWidth: 128,
    },
  };
});
